import useHalls from "../../../../api/hooks/useHalls/useHalls.ts";
import ControlledSelect, { ControlledSelectProps } from "../../../ControlledInputs/ControlledSelect.tsx";
import { FC } from "react";


const HallSelect: FC<Omit<ControlledSelectProps, "options" | "disabled"> & { onOptionsChange?: () => void; }> = (props) => {
  const { halls, isFetching } = useHalls();

  return (
    <ControlledSelect disabled={isFetching} options={halls?.filter(h => h.isBookable)?.map(h => ({
      label: h.name,
      value: h.id,
    })) || []} {...props} />
  );
};

export default HallSelect;
